import { Directive, HostListener, Inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeviceService } from '@shared/tools/device.service';
import { DEVICE_SIZE, mediaConfig } from '@core/models/deviceSize.model';

@Directive({
  selector: '[limitUp]',
})
export class LimitUpDirective implements OnInit {
  private hasView = false;
  deviceSize!: DEVICE_SIZE;

  @Input() set limitUp(deviceSize: DEVICE_SIZE) {
    this.deviceSize = deviceSize;
  }

  constructor(
    private deviceService: DeviceService,
    @Inject(TemplateRef) private templateRef: TemplateRef<any>,
    @Inject(ViewContainerRef) private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.testElement();
  }

  @HostListener('window:resize') testElement() {
    const sizeScreen = this.deviceService.getSizeScreen().width;
    const limitWidth = mediaConfig!.mediaFormats![this.deviceSize]!.width!;
    const showComponente = sizeScreen >= limitWidth;

    if (showComponente && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!showComponente && this.hasView) {
      this.viewContainer.remove();
      this.hasView = false;
    }
  }
}
